export default "__VITE_ASSET__CnMu98KK__"